import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Grid,
  Typography,
  IconButton,
  Collapse,
  Paper,
  MenuList,
  MenuItem,
  ListItemIcon,
} from '@material-ui/core';
import {
  ArrowBack,
  Remove
} from '@material-ui/icons';
import Alert from '@material-ui/lab/Alert';
import { RegisterForm } from './styles';
import { deleteBoard, listBoards } from './services.js';

const Register = () => {
  const [boards, setBoards] = useState();
  const [error, setError] = useState();
  const [success, setSuccess] = useState();

  const removeBoard = async (id) => {
    setError('');
    try {
      await deleteBoard(id);
      getBoards();
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 5000);
    } catch(e) {
      setError(e.message);
    }
  }

  const getBoards = async () => {
    try {
      const boardsData = await listBoards();
      setBoards(boardsData);
    } catch(e) {
      setError(e.message);
    }
  }

  useEffect(() => {
    getBoards();
  }, []);

  return (
    <RegisterForm>
      <Grid container spacing={2} style={{ alignItems: 'center', marginBottom: 16 }}>
        <Grid item>
          <IconButton component={Link} to="/admin">
            <ArrowBack />
          </IconButton>
        </Grid>
        <Grid item>
          <Typography variant="h5">
            Remover Board
          </Typography>
        </Grid>
      </Grid>
      {
        boards && boards.length > 0 && (
          <Paper style={{ width: '100%' }}>
            <MenuList>
              {
                boards.map(item => (
                  <MenuItem style={{ paddingTop: 16, paddingBottom: 16 }} onClick={() => removeBoard(item.id)}>
                    <ListItemIcon>
                      <Remove />
                    </ListItemIcon>
                    {item.name}
                  </MenuItem>
                ))
              }
            </MenuList>
          </Paper>
        )
      }
      {
        boards && boards.length === 0 && (
          <Typography>
            Nenhum board registrado
          </Typography>
        )
      }
      <Collapse in={success}>
        <Alert severity="success">Board removido com sucesso!</Alert>
      </Collapse>
      <Collapse in={error}>
        <Alert severity="error">{error}</Alert>
      </Collapse>
    </RegisterForm>
  )
}

export default Register;
